<template>
<div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
  <div class="sm:mx-auto sm:w-full sm:max-w-md">
    <router-link to="/" class="block mx-auto w-48">
      <img src="../assets/TheTutorIndex-logo-horizontal.svg" alt="The Tutor Index">
    </router-link>
    <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
      Forgotten your password?
    </h2>
    <p class="mt-2 text-center text-sm text-gray-600 max-w">
      Alternatively,
      <router-link to="/sign-in" class="font-medium text-blue-600 hover:text-blue-500">
        Sign in
      </router-link>
    </p>
  </div>

  <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
    <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
      <form @submit.prevent="resetPassword" class="space-y-6">

        <div>
          <label for="email" class="block text-sm font-medium text-gray-700">
            Enter your email address to reset your password.
          </label>
          <div class="mt-1">
            <input v-model="username" id="email" name="email" type="email" autocomplete="email" required class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
          </div>
          <p v-if="$v.username.$dirty && !$v.username.required" class="mt-2 text-sm text-red-600">Please enter your email address.</p>
          <p v-if="$v.username.$dirty && !$v.username.email" class="mt-2 text-sm text-red-600">Please enter a valid email address.</p>
        </div>

        <div>
            <tti-button type="submit" :loading="submitting" :disabled="submitting" class="w-full justify-center">Reset password</tti-button>
        </div>

        <!-- <p v-if="unknownUsername" class="mt- text-sm text-red-600">Sorry, we can’t find an account with this email address.</p> -->

        <!-- <div class="flex items-center justify-end">
          <div class="text-sm">
            <router-link to="/sign-in" class="font-medium text-blue-600 hover:text-blue-500">
                Sign In
            </router-link>
          </div>
        </div> -->

      </form>

    </div>
  </div>
</div>
</template>
<script>
import { required, email } from 'vuelidate/lib/validators'

import AuthService from '@/services/AuthServices'
const authService = new AuthService()

export default {
    components: {
        'tti-button': () => import('./TailwindButton')
    },
    data() {
        return {
            username: null,
            submitting: false,
            // unknownUsername: false
        }
    },
    validations: {
        username: {
            required,
            email
        }
    },
    methods: {
        async resetPassword() {
            // this.unknownUsername = false;
            this.$v.$touch();
            if (this.$v.$invalid) return;

            this.submitting = true;
            let response;
            try {
                response = await authService.forgotPassword(this.username);
            }
            catch {
                // this.unknownUsername = true;
                return;
            } 
            finally {
                this.submitting = false;
            }
            
            this.$router.push({
                path: `/reset-password/${response.data.UserId}`
            });
        }
    }
}
</script>